import styled, { css } from 'styled-components';
import { } from '../../'

const dragActive = css`
    border-color: #78e5d5;
`;

const dragReject = css`
    border-color: #e57878;
`;

export const Container = styled.div`
    width: 100%;
    background: #FFF;
    border-radius: 4px;
`;

export const DropContainer = styled.div.attrs({
    className: "dropzone"
})`
    border: 2px dashed #ddd;
    border-radius: 4px;
    cursor: pointer;

    transition: height 0.2s ease;

    ${props => props.isDragActive && dragActive};
    ${props => props.isDragReject && dragReject};    
`;

const messageColors = {
    default: '#999',
    error: '#e57878',
    success: '#78e5d5',
}

export const UploadMessage = styled.p`
    display: flex;
    color: ${props => messageColors[props.type || 'default']};
    justify-content: center;
    padding: 25px 0 15px 0;
    font-weight: bold;
`;

export const ErrorMessageContainer = styled.div`
    display: flex;
    height: 20px;
    align-items: center;
    justify-content: flex-start;
    padding: 20px 0 10px 0;
`;

export const ErrorMessage = styled.p`
    color: ${props => messageColors[props.type || 'default']};
    font-weight: bold;
    font-size: 14px;
`;